import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState: Record<string, any> = {};

export const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    setConstant(state, action: PayloadAction<[string, any]>) {
      state[action.payload[0]] = action.payload[1];
    },
  },
});

export const { setConstant } = constantsSlice.actions;
export const selectConstant = (key: string) => (state: RootState) => {
  return state.constants[key];
};

export default constantsSlice.reducer;
